// 冷却由服务端执行。这里只负责提示，不自动提交、存密码或把客户端时间当成权限。
export function createSharePasswordCooldown ({ onChange, now = () => Date.now(), later = setTimeout, cancel = clearTimeout }) {
  let deadline = 0, timer, closed = false
  const tick = () => {
    if (closed) return
    const remaining = Math.max(0, Math.ceil((deadline - now()) / 1000))
    onChange(remaining)
    if (remaining) timer = later(tick, Math.min(1000, Math.max(1, deadline - now())))
  }
  return {
    apply (error) {
      if (closed || !error || error.status !== 429) return false
      const headers = error.response && error.response.headers
      const value = headers && (typeof headers.get === 'function' ? headers.get('Retry-After') : headers['retry-after'] || headers['Retry-After'])
      const seconds = /^\d{1,5}$/.test(String(value || '')) ? Math.min(3600, Math.max(1, Number(value))) : 30
      deadline = Math.max(deadline, now() + seconds * 1000)
      cancel(timer); tick()
      return true
    },
    close () { closed = true; cancel(timer) }
  }
}
